export const template = (orgUsername = '{{ctrl.orgUsername}}') => `
    <aside class="business-promo business-promo-for-report-runs">
      <!-- Illustration -->
      <figure>
        <i class="icon-run-now-click-illo"></i>
      </figure>
      <!-- @Illustration -->

      <section class="promo-wrapper">

        <!-- Header -->
        <header class="promo-header">
          <h3 class="promo-heading">Upgrade your account</h3>
          <span class="promo-sub-heading">to streamline collaboration</span>
        </header>
        <!-- @Header -->

        <!-- Body -->
        <div class="promo-body">
          <ul class="promo-props">
            <li class="promo-prop icon-check-mark">Run anyone's reports, anytime</li>
            <li class="promo-prop icon-check-mark">Schedule automatic runs</li>
            <li class="promo-prop icon-check-mark">Collaboratively edit reports</li>
          </ul>
        </div>
        <!-- @Body -->

        <!-- Footer -->
        <footer class="promo-footer">
          <a class="promo-cta-btn btn btn-lg btn-filled-primary" target="_blank" href="/organizations/${orgUsername}/start_trial?trk_element_id=2" target="_self">Learn More</a>
        </footer>
        <!-- @Footer -->

      </section>
    </aside>
  `;

export const BusinessPromoForReportRunsComponent: angular.IComponentOptions = {
  controllerAs: 'ctrl',
  bindings: {
    orgUsername: '<',
  },
  template: template(),
};
